import {useState} from 'react';
import {buildRoomShareUrl} from '../roomLinks';

type Props={slug:string;title:string;description?:string;className?:string};

async function copyText(value:string){
 if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(value);return;}
 const field=document.createElement('textarea');field.value=value;field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';document.body.appendChild(field);field.select();const copied=document.execCommand('copy');field.remove();if(!copied)throw new Error('Der Link konnte nicht kopiert werden.');
}

export function ShareRoomButton({slug,title,description,className=''}:Props){
 const[notice,setNotice]=useState('');const[busy,setBusy]=useState(false);
 async function share(){
  const url=buildRoomShareUrl(slug);const payload={title,text:description||`${title} bei Katrin & Rayk`,url};setBusy(true);setNotice('');
  try{
   if(navigator.share&&(!navigator.canShare||navigator.canShare(payload))){await navigator.share(payload);setNotice('Link geteilt.');}
   else{await copyText(url);setNotice('Link kopiert.');}
  }catch(reason){if(reason instanceof DOMException&&reason.name==='AbortError')return;try{await copyText(url);setNotice('Link kopiert.');}catch{setNotice('Teilen war nicht möglich.');}}
  finally{setBusy(false);window.setTimeout(()=>setNotice(''),2600);}
 }
 return <span className={`room-share ${className}`}><button type="button" onClick={()=>void share()} disabled={busy} aria-label={`${title} teilen`}><span aria-hidden="true">↗</span>{busy?'Wird geöffnet …':'Link teilen'}</button>{notice&&<small role="status">{notice}</small>}</span>;
}
